import { render, staticRenderFns } from "./ClientOfAffiliates.vue?vue&type=template&id=6e6ef741&scoped=true"
import script from "./ClientOfAffiliates.vue?vue&type=script&lang=js"
export * from "./ClientOfAffiliates.vue?vue&type=script&lang=js"
import style0 from "./ClientOfAffiliates.vue?vue&type=style&index=0&id=6e6ef741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6ef741",
  null
  
)

export default component.exports